import React from 'react';
import clsx from 'clsx';
import { Checkbox, Radio } from 'semantic-ui-react';

const OnOffLabel = ({
  checked,
  className,
  defaultIndeterminate,
  disabled,
  label,
  onClick,
  single,
  toggle,
}) => (
  <>
    {!single && (
    <Checkbox
      disabled={disabled}
      toggle={toggle}
      checked={checked}
      defaultIndeterminate={defaultIndeterminate}
      label={label}
      className={clsx('aridhia-on-off-label toggle-label', className)}
      onClick={disabled ? undefined : onClick}
    />
    )}
    {single && (
      <Radio
        disabled={disabled}
        checked={checked}
        label={label}
        className={clsx('aridhia-on-off-label-single toggle-label', className)}
        onClick={disabled ? undefined : onClick}
      />
    )}
  </>
);

export default OnOffLabel;
